import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import { Text } from "react-native";
import { View } from "ui/atoms/view";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { SlashIcon } from "ui/gluestack/icon";
import { DeleteMedicationModal } from "../modals/DeleteMedicationModal";
import { useRef } from "react";
import clsx from "clsx";
interface Props {
  className?: string;
  medication?: MedicationModel;
}
export function MedicationEndedWarning({ className, medication }: Props) {
  const isEnded = !!medication?.is_past_end_date;

  const discontinueRef =
    useRef<React.ComponentRef<typeof DeleteMedicationModal>>(null);

  const startDiscontinue = () => {
    discontinueRef.current?.show(medication);
  };

  if (!isEnded) {
    return null;
  }

  return (
    <View
      className={clsx(
        "rounded bg-red-200 py-5 px-4 items-center justify-center",
        className,
      )}
    >
      <Text className="text-typography-900 font-semibold text-md mb-2">
        Medication has ended
      </Text>
      <Text className="text-typography-900 text-xs">
        The planned end date has already passed, you can still administer the
        medication but it is not recommended.
      </Text>

      <View className="mt-5 justify-end flex-row w-full">
        <Button
          action="negative"
          size="sm"
          variant="outline"
          className="bg-white"
          onPress={startDiscontinue}
        >
          <ButtonText className="hidden xl:block">Discontinue</ButtonText>
          <ButtonIcon as={SlashIcon} />
        </Button>
      </View>

      <DeleteMedicationModal ref={discontinueRef} />
    </View>
  );
}
